module.exports = __webpack_public_path__ + "static/img/swiper_next.b824ffd.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/swiper_next.png
// module id = XJrX
// module chunks = 0